'use strict';

const GalleryWrapperView = require('../views/GalleryWrapperView');
const { connectGalleryModalStoreToView } = require('../helpers/connectViewToStoresHelpers');

/**
 * GalleryModalView extends GalleryWrapperView
 * Top Level Connected Wrapper for Views in Gallery Modal
 */
const GalleryModalView = connectGalleryModalStoreToView(GalleryWrapperView).extend({
    isModal: true,

    constructor({ pageType } = {}) {
        this.pageType = pageType;

        GalleryWrapperView.prototype.constructor.apply(this, arguments);
    },

    /**
     * Processes galleryStore and sets props before render
     *
     * @param {GalleryStore} galleryStore
     * @param {GalleryModalStore} galleryModalStore
     * @see /gallery/stores/GalleryStore
     * @see /gallery/modal/GalleryModalStore
     */
    getPropsFromStores(galleryStore, galleryModalStore) {
        const props = GalleryWrapperView.prototype.getPropsFromStores.apply(this, arguments);

        if (galleryModalStore.isHidden()) {
            return Object.assign(props, {
                titleTag: galleryModalStore.getOriginalPageTitleTag(),
            });
        }

        return props;
    },
});

module.exports = GalleryModalView;



// WEBPACK FOOTER //
// ./assets/js/gallery/modal/GalleryModalView.es.js